export default "__VITE_ASSET__B9IDBR0i__"